/** Canonical user-role labels and badge variants — do not redefine locally. */
export const ROLES = [
  "superuser",
  "manager",
  "service-tech",
  "warehouse",
  "cmm",
] as const;

export type Role = (typeof ROLES)[number];

export const ROLE_LABELS: Record<string, string> = {
  superuser: "Суперпользователь",
  manager: "Менеджер",
  "service-tech": "Техник",
  warehouse: "Склад",
  cmm: "CMM",
};

export function roleLabel(role?: string): string {
  return ROLE_LABELS[role ?? ""] ?? role ?? "—";
}

export function roleVariant(
  role?: string,
): "default" | "secondary" | "outline" {
  switch (role) {
    case "service-tech":
      return "default";
    case "manager":
    case "superuser":
      return "secondary";
    default:
      return "outline";
  }
}
